import flower from '@/assets/loader/flower.svg'
import { cn } from '@/lib/utils'

/** Иконка кредитов — фирменный «мягкий цветок» (тот же, что в лоадере). Одна на всю
 *  студию: где речь о кредитах, стоит она, а не случайная иконка из набора.
 *  `muted` — серый силуэт той же формы (маска + токен цвета, не перекрашенный
 *  файл): для длинных списков, где голубой цветок у каждой строки рябит. */
export const CreditIcon = ({
  className,
  muted = false,
}: {
  className?: string
  muted?: boolean
}) =>
  muted ? (
    <span
      aria-hidden="true"
      className={cn('inline-block size-4 shrink-0 bg-muted-foreground', className)}
      style={{
        maskImage: `url("${flower}")`,
        WebkitMaskImage: `url("${flower}")`,
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
      }}
    />
  ) : (
    <img
      src={flower}
      alt=""
      aria-hidden="true"
      draggable={false}
      className={cn('size-4 shrink-0', className)}
    />
  )
